import { c as _c } from "react/compiler-runtime";
import { LoadingFour } from "@icon-park/svg";
import clsx from "clsx";
import { FC } from "react";
import Icon from "../Icon";
interface LoaderProps {
  size?: "sm" | "md" | "lg";
  className?: string;
  inverted?: boolean;
  color?: "primary" | "neutral";
}
const Loader: FC<LoaderProps> = t0 => {
  const $ = _c(11);
  const {
    size: t1,
    className,
    inverted,
    color: t2
  } = t0;
  const size = t1 === undefined ? "sm" : t1;
  const color = t2 === undefined ? "primary" : t2;
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      sm: 16,
      md: 20,
      lg: 48
    };
    $[0] = t3;
  } else {
    t3 = $[0];
  }
  const sizes = t3 as const;
  const t4 = !inverted && color === "primary";
  const t5 = !inverted && color === "neutral";
  let t6;
  if ($[1] !== className || $[2] !== inverted || $[3] !== t4 || $[4] !== t5) {
    t6 = clsx("inline-flex flex-none", className, {
      "text-primary-800": t4,
      "text-neutral-325": t5,
      "text-neutral-0": inverted
    });
    $[1] = className;
    $[2] = inverted;
    $[3] = t4;
    $[4] = t5;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  const t7 = sizes[size];
  let t8;
  if ($[6] !== t7) {
    t8 = <Icon size={t7} icon={LoadingFour} className="animate-spin motion-reduce:[animation-duration:3s] flex-none" />;
    $[6] = t7;
    $[7] = t8;
  } else {
    t8 = $[7];
  }
  let t9;
  if ($[8] !== t6 || $[9] !== t8) {
    t9 = <span aria-hidden="true" className={t6}>{t8}</span>;
    $[8] = t6;
    $[9] = t8;
    $[10] = t9;
  } else {
    t9 = $[10];
  }
  return t9;
};
export default Loader;